// Local translations
export const T = {
  en_GB: {
    editClient: "Edit Client",
    addNewClient: "Add New Client",
    updateDescription: "Update the client information below.",
    createDescription: "Fill in the information to create a new client.",
    type: "Type",
    selectType: "Select type",
    person: "Person",
    company: "Company",
    group: "Group",
    name: "Name",
    namePlaceholderPerson: "John Doe",
    namePlaceholderCompany: "Acme Corp",
    namePlaceholderGroup: "Doe Family",
    email: "Email",
    emailPlaceholder: "email@example.com",
    mobilePhone: "Mobile Phone",
    mobilePhonePlaceholder: "+1 (555) 123-4567",
    ssn: "SSN",
    ssnPlaceholder: "123-45-6789",
    dateOfBirth: "Date of Birth",
    orgId: "Org Identifier",
    orgIdPlaceholder: "Organization number",
    country: "Country",
    selectCountry: "Select country",
    clear: "Clear",
    owner: "Client Owner",
    selectOwner: "Select owner",
    searchOwner: "Search users...",
    noOwnerResults: "No users found",
    unnamedUser: "Unnamed user",
    default: "Default",
    noFieldsInTab: "No fields in this tab",
    cancel: "Cancel",
    save: "Save",
    addClient: "Add Client",
    somethingWentWrong: "Something went wrong",
    failedToSave: "Failed to save client",
    accessManageDenied:
      "Only the client owner or an administrator can change ownership and access.",
    enterField: (field: string) => `Enter ${field}`,
    selectField: (field: string) => `Select ${field}`,
    language: "Language",
    selectLanguage: "Select language",
    costCategory: "Cost Category",
    selectCostCategory: "Select cost category",
  },
  nb_NO: {
    editClient: "Rediger kunde",
    addNewClient: "Legg til ny kunde",
    updateDescription: "Oppdater kundeinformasjonen nedenfor.",
    createDescription: "Fyll inn informasjonen for a opprette en ny kunde.",
    type: "Type",
    selectType: "Velg type",
    person: "Person",
    company: "Bedrift",
    group: "Gruppe",
    name: "Navn",
    namePlaceholderPerson: "Ola Nordmann",
    namePlaceholderCompany: "Bedrift AS",
    namePlaceholderGroup: "Familien Nordmann",
    email: "E-post",
    emailPlaceholder: "epost@eksempel.no",
    mobilePhone: "Mobiltelefon",
    mobilePhonePlaceholder: "+47 999 99 999",
    ssn: "Personnummer",
    ssnPlaceholder: "123456 78901",
    dateOfBirth: "Fødselsdato",
    orgId: "Organisasjonsnummer",
    orgIdPlaceholder: "Organisasjonsnummer",
    country: "Land",
    selectCountry: "Velg land",
    clear: "Fjern",
    owner: "Kundeeier",
    selectOwner: "Velg eier",
    searchOwner: "Søk etter brukere...",
    noOwnerResults: "Ingen brukere funnet",
    unnamedUser: "Bruker uten navn",
    default: "Standard",
    noFieldsInTab: "Ingen felter i denne fanen",
    cancel: "Avbryt",
    save: "Lagre",
    addClient: "Legg til kunde",
    somethingWentWrong: "Noe gikk galt",
    failedToSave: "Kunne ikke lagre kunden",
    accessManageDenied: "Bare kundens eier eller en administrator kan endre eierskap og tilgang.",
    enterField: (field: string) => `Skriv inn ${field}`,
    selectField: (field: string) => `Velg ${field}`,
    language: "Språk",
    selectLanguage: "Velg språk",
    costCategory: "Kostnadskategori",
    selectCostCategory: "Velg kostnadskategori",
  },
} as const;
